export default __webpack_public_path__ + "static/B0312-e0e3e0e563187e454a24935d0c275bd0.png";